var map = {
	"./BabyBee.png": 946,
	"./BasicBee.png": 8098,
	"./BearBee.png": 6603,
	"./Beequips/AutumnSunhat.png": 8505,
	"./Beequips/Bandage.png": 6434,
	"./Beequips/BangSnap.png": 4254,
	"./Beequips/BeadLizard.png": 1720,
	"./Beequips/BeesmasTop.png": 4729,
	"./Beequips/BeesmasTreeHat.png": 1843,
	"./Beequips/Beret.png": 626,
	"./Beequips/BottleCap.png": 1722,
	"./Beequips/BubbleLight.png": 2729,
	"./Beequips/CamoBandana.png": 7952,
	"./Beequips/CamphorLipBalm.png": 2893,
	"./Beequips/CandyRing.png": 3915,
	"./Beequips/CharmBracelet.png": 9095,
	"./Beequips/DemonTalisman.png": 3663,
	"./Beequips/ElectricCandle.png": 2031,
	"./Beequips/ElfCap.png": 6526,
	"./Beequips/FestiveWreath.png": 7006,
	"./Beequips/Icicles.png": 3973,
	"./Beequips/Kazoo.png": 2536,
	"./Beequips/Lei.png": 1837,
	"./Beequips/LumpOfCoal.png": 4780,
	"./Beequips/PaperAngel.png": 7792,
	"./Beequips/Paperclip.png": 5900,
	"./Beequips/PeppermintAntennas.png": 5778,
	"./Beequips/Pinecone.png": 6245,
	"./Beequips/PinkEraser.png": 4479,
	"./Beequips/PinkShades.png": 7794,
	"./Beequips/Poinsettia.png": 2323,
	"./Beequips/ReindeerAntlers.png": 7940,
	"./Beequips/Remove.png": 1804,
	"./Beequips/RoseHeadband.png": 4510,
	"./Beequips/SingleMitten.png": 8285,
	"./Beequips/SmileySticker.png": 9450,
	"./Beequips/SnowTiara.png": 5344,
	"./Beequips/Snowglobe.png": 3345,
	"./Beequips/Sweatband.png": 5796,
	"./Beequips/Thimble.png": 1225,
	"./Beequips/Thumbtack.png": 898,
	"./Beequips/ToyDrum.png": 4469,
	"./Beequips/ToyHorn.png": 2079,
	"./Beequips/WarmScarf.png": 8772,
	"./Beequips/Whistle.png": 7815,
	"./Bees.psd": 7539,
	"./BomberBee.png": 8204,
	"./BouyantBee.png": 9109,
	"./BraveBee.png": 3887,
	"./BubbleBee.png": 8597,
	"./BuckoBee.png": 1116,
	"./BumbleBee.png": 4742,
	"./CarpenterBee.png": 4600,
	"./CobaltBee.png": 86,
	"./CommanderBee.png": 6781,
	"./CoolBee.png": 1581,
	"./CrimsonBee.png": 8457,
	"./DemoBee.png": 6514,
	"./DemonBee.png": 5142,
	"./DiamondBee.png": 2423,
	"./DigitalBee.png": 984,
	"./EmptyHive.png": 2340,
	"./ExhaustedBee.png": 570,
	"./Faces/Baby.png": 7239,
	"./Faces/Basic.png": 8596,
	"./Faces/Bear.png": 200,
	"./Faces/Bomber.png": 8559,
	"./Faces/Bouyant.png": 7713,
	"./Faces/Brave.png": 1811,
	"./Faces/Bubble.png": 1064,
	"./Faces/Bucko.png": 8297,
	"./Faces/Bumble.png": 1390,
	"./Faces/Carpenter.png": 715,
	"./Faces/Cobalt.png": 8711,
	"./Faces/Commander.png": 5895,
	"./Faces/Cool.png": 9008,
	"./Faces/Crimson.png": 4563,
	"./Faces/Demo.png": 5241,
	"./Faces/Demon.png": 7697,
	"./Faces/Diamond.png": 7613,
	"./Faces/Digital.png": 318,
	"./Faces/Exhausted.png": 7480,
	"./Faces/Festive.png": 5665,
	"./Faces/Fire.png": 4465,
	"./Faces/Frosty.png": 294,
	"./Faces/Fuzzy.png": 5589,
	"./Faces/Gummy.png": 2260,
	"./Faces/Hasty.png": 1373,
	"./Faces/Honey.png": 2621,
	"./Faces/Lion.png": 8472,
	"./Faces/Looker.png": 6641,
	"./Faces/Musical.png": 6689,
	"./Faces/Ninja.png": 199,
	"./Faces/Photon.png": 4807,
	"./Faces/Precise.png": 2252,
	"./Faces/Puppy.png": 2141,
	"./Faces/Rad.png": 3021,
	"./Faces/Rage.png": 749,
	"./Faces/Rascal.png": 2164,
	"./Faces/Riley.png": 6692,
	"./Faces/Shocked.png": 297,
	"./Faces/Shy.png": 8310,
	"./Faces/Spicy.png": 3866,
	"./Faces/Stubborn.png": 468,
	"./Faces/Tabby.png": 7013,
	"./Faces/Tadpole.png": 3580,
	"./Faces/Vector.png": 700,
	"./Faces/Vicious.png": 5506,
	"./Faces/Windy.png": 4070,
	"./FestiveBee.png": 5995,
	"./FireBee.png": 5875,
	"./FrostyBee.png": 9976,
	"./FuzzyBee.png": 9818,
	"./Gifted/BabyBee.png": 4597,
	"./Gifted/BasicBee.png": 3725,
	"./Gifted/BearBee.png": 9116,
	"./Gifted/BomberBee.png": 9910,
	"./Gifted/BouyantBee.png": 5199,
	"./Gifted/BraveBee.png": 8579,
	"./Gifted/BubbleBee.png": 840,
	"./Gifted/BuckoBee.png": 7200,
	"./Gifted/BumbleBee.png": 7266,
	"./Gifted/CarpenterBee.png": 9728,
	"./Gifted/CobaltBee.png": 7090,
	"./Gifted/CommanderBee.png": 1951,
	"./Gifted/CoolBee.png": 9336,
	"./Gifted/CrimsonBee.png": 1563,
	"./Gifted/DemoBee.png": 3857,
	"./Gifted/DemonBee.png": 7624,
	"./Gifted/DiamondBee.png": 9719,
	"./Gifted/DigitalBee.png": 2421,
	"./Gifted/ExhaustedBee.png": 5043,
	"./Gifted/FestiveBee.png": 6293,
	"./Gifted/FireBee.png": 1847,
	"./Gifted/FrostyBee.png": 8008,
	"./Gifted/FuzzyBee.png": 4662,
	"./Gifted/GummyBee.png": 7215,
	"./Gifted/HastyBee.png": 7604,
	"./Gifted/HoneyBee.png": 2178,
	"./Gifted/LionBee.png": 8552,
	"./Gifted/LookerBee.png": 6485,
	"./Gifted/MusicalBee.png": 7077,
	"./Gifted/NinjaBee.png": 8105,
	"./Gifted/PhotonBee.png": 6645,
	"./Gifted/PreciseBee.png": 3315,
	"./Gifted/PuppyBee.png": 1586,
	"./Gifted/RadBee.png": 7201,
	"./Gifted/RageBee.png": 9293,
	"./Gifted/RascalBee.png": 5450,
	"./Gifted/RileyBee.png": 2087,
	"./Gifted/ShockedBee.png": 5679,
	"./Gifted/ShyBee.png": 1147,
	"./Gifted/SpicyBee.png": 8303,
	"./Gifted/StubbornBee.png": 1853,
	"./Gifted/TabbyBee.png": 3032,
	"./Gifted/TadpoleBee.png": 9173,
	"./Gifted/VectorBee.png": 7700,
	"./Gifted/ViciousBee.png": 6686,
	"./Gifted/WindyBee.png": 7024,
	"./GummyBee.png": 895,
	"./HastyBee.png": 2296,
	"./HoneyBee.png": 514,
	"./Hover/BabyBee.png": 7777,
	"./Hover/BasicBee.png": 5661,
	"./Hover/BearBee.png": 618,
	"./Hover/BomberBee.png": 2110,
	"./Hover/BouyantBee.png": 5538,
	"./Hover/BraveBee.png": 5001,
	"./Hover/BubbleBee.png": 7478,
	"./Hover/BuckoBee.png": 4702,
	"./Hover/BumbleBee.png": 2934,
	"./Hover/CarpenterBee.png": 4205,
	"./Hover/CobaltBee.png": 7174,
	"./Hover/CommanderBee.png": 1324,
	"./Hover/CoolBee.png": 3975,
	"./Hover/CrimsonBee.png": 6122,
	"./Hover/DemoBee.png": 9985,
	"./Hover/DemonBee.png": 6779,
	"./Hover/DiamondBee.png": 6069,
	"./Hover/DigitalBee.png": 9983,
	"./Hover/EmptyHive.png": 3422,
	"./Hover/ExhaustedBee.png": 5596,
	"./Hover/FestiveBee.png": 5632,
	"./Hover/FireBee.png": 2662,
	"./Hover/FrostyBee.png": 2461,
	"./Hover/FuzzyBee.png": 2645,
	"./Hover/Gifted/BabyBee.png": 8566,
	"./Hover/Gifted/BasicBee.png": 596,
	"./Hover/Gifted/BearBee.png": 8713,
	"./Hover/Gifted/BomberBee.png": 3358,
	"./Hover/Gifted/BouyantBee.png": 1125,
	"./Hover/Gifted/BraveBee.png": 2802,
	"./Hover/Gifted/BubbleBee.png": 1004,
	"./Hover/Gifted/BuckoBee.png": 5428,
	"./Hover/Gifted/BumbleBee.png": 2035,
	"./Hover/Gifted/CarpenterBee.png": 4933,
	"./Hover/Gifted/CobaltBee.png": 9598,
	"./Hover/Gifted/CommanderBee.png": 4871,
	"./Hover/Gifted/CoolBee.png": 6387,
	"./Hover/Gifted/CrimsonBee.png": 7944,
	"./Hover/Gifted/DemoBee.png": 7252,
	"./Hover/Gifted/DemonBee.png": 510,
	"./Hover/Gifted/DiamondBee.png": 1006,
	"./Hover/Gifted/DigitalBee.png": 2834,
	"./Hover/Gifted/ExhaustedBee.png": 70,
	"./Hover/Gifted/FestiveBee.png": 7784,
	"./Hover/Gifted/FireBee.png": 9544,
	"./Hover/Gifted/FrostyBee.png": 8334,
	"./Hover/Gifted/FuzzyBee.png": 387,
	"./Hover/Gifted/GummyBee.png": 6108,
	"./Hover/Gifted/HastyBee.png": 5010,
	"./Hover/Gifted/HoneyBee.png": 9918,
	"./Hover/Gifted/LionBee.png": 2010,
	"./Hover/Gifted/LookerBee.png": 9555,
	"./Hover/Gifted/MusicalBee.png": 6014,
	"./Hover/Gifted/NinjaBee.png": 3183,
	"./Hover/Gifted/PhotonBee.png": 4454,
	"./Hover/Gifted/PreciseBee.png": 8084,
	"./Hover/Gifted/PuppyBee.png": 8209,
	"./Hover/Gifted/RadBee.png": 8304,
	"./Hover/Gifted/RageBee.png": 9535,
	"./Hover/Gifted/RascalBee.png": 5893,
	"./Hover/Gifted/RileyBee.png": 5193,
	"./Hover/Gifted/ShockedBee.png": 4711,
	"./Hover/Gifted/ShyBee.png": 8226,
	"./Hover/Gifted/SpicyBee.png": 1459,
	"./Hover/Gifted/StubbornBee.png": 341,
	"./Hover/Gifted/TabbyBee.png": 7988,
	"./Hover/Gifted/TadpoleBee.png": 3723,
	"./Hover/Gifted/VectorBee.png": 1643,
	"./Hover/Gifted/ViciousBee.png": 4144,
	"./Hover/Gifted/WindyBee.png": 9444,
	"./Hover/GummyBee.png": 3850,
	"./Hover/HastyBee.png": 6613,
	"./Hover/HoneyBee.png": 8495,
	"./Hover/LionBee.png": 3999,
	"./Hover/LookerBee.png": 5063,
	"./Hover/MusicalBee.png": 8631,
	"./Hover/NinjaBee.png": 426,
	"./Hover/PhotonBee.png": 1902,
	"./Hover/PreciseBee.png": 4904,
	"./Hover/PuppyBee.png": 879,
	"./Hover/RadBee.png": 4595,
	"./Hover/RageBee.png": 6787,
	"./Hover/RascalBee.png": 2613,
	"./Hover/RileyBee.png": 2755,
	"./Hover/ShockedBee.png": 109,
	"./Hover/ShyBee.png": 640,
	"./Hover/SpicyBee.png": 2303,
	"./Hover/StubbornBee.png": 8118,
	"./Hover/TabbyBee.png": 1202,
	"./Hover/TadpoleBee.png": 2355,
	"./Hover/VectorBee.png": 6278,
	"./Hover/ViciousBee.png": 3985,
	"./Hover/WindyBee.png": 5303,
	"./LionBee.png": 3231,
	"./LookerBee.png": 1668,
	"./MusicalBee.png": 2766,
	"./Mutations/Attack.png": 2292,
	"./Mutations/Bee Ability Rate.png": 9403,
	"./Mutations/Convert Amount.png": 1928,
	"./Mutations/Critical Chance.png": 6977,
	"./Mutations/Energy.png": 8598,
	"./Mutations/Gather Amount.png": 4087,
	"./Mutations/Instant Conversion.png": 3884,
	"./Mutations/Movespeed.png": 7079,
	"./NinjaBee.png": 2640,
	"./PhotonBee.png": 7538,
	"./PreciseBee.png": 4471,
	"./PuppyBee.png": 4998,
	"./RadBee.png": 1348,
	"./RageBee.png": 1233,
	"./RascalBee.png": 6373,
	"./RileyBee.png": 3540,
	"./ShockedBee.png": 4782,
	"./ShyBee.png": 3594,
	"./SpicyBee.png": 9898,
	"./StubbornBee.png": 4461,
	"./TabbyBee.png": 254,
	"./TadpoleBee.png": 5892,
	"./Tools/Bond.png": 7840,
	"./Tools/Calculator.png": 3913,
	"./Tools/ComingSoon.png": 4863,
	"./Tools/Planner.png": 9891,
	"./VectorBee.png": 8423,
	"./ViciousBee.png": 930,
	"./WindyBee.png": 923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3215;